import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { shiftAction } from './shift.actions';
import { ShiftService } from '../service/shift.service';

@Injectable()
export class ShiftEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private shiftService: ShiftService
  ) {}

  shiftListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shiftAction.shiftListRequest),
      tap((_) => this.logger.debug('@Effect [Shift] shift list request ')),
      switchMap(({ payload }) => {
        return this.shiftService.list({ ...payload }).pipe(
          map((response) => {
            return shiftAction.shiftListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  shiftDetailRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shiftAction.viewShiftRequest),
      tap((_) => this.logger.debug('@Effect [Shift] shift detail request ')),
      switchMap((payload) => {
        return this.shiftService.detail(payload.docNo).pipe(
          map((response) => {
            return shiftAction.viewShiftResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });
}
